import React from 'react';
import styles from './_style.module.scss';
import OptionsCommon from 'components/quote_builder_widget/form/options/OptionsCommon.jsx';

const OptionLengthWithUnit = ({ id, drawing, option, unit }) => {
  const formattedValue = (value) => {
    let toFormat = parseFloat(value);
    let formatted = (Number.isNaN(toFormat) ? 0 : toFormat).toFixed(
      unit === 'in' ? 4 : 2
    );

    return formatted;
  };

  const [isVisible, value, onChange, highlighted] = OptionsCommon({
    formattedValue,
    id,
    drawing,
    option,
    unit,
  });

  const formatValueDecimal = (e) => {
    let formattedValueRes = formattedValue(e.target.value);
    onChange({ target: { value: formattedValueRes } });
  };

  return (
    <div className={styles.formGroup}>
      <label className={styles.label}>{option.presented_name}</label>
      <div className={styles.inputWrapper}>
        <input
          type="text"
          className={styles.input}
          value={value}
          onChange={onChange}
          onBlur={formatValueDecimal}
          readOnly={option.readonly}
          autoComplete="off"
        />
        <span className={styles.unitSuffix}>{unit}</span>
      </div>
    </div>
  );
};

export default OptionLengthWithUnit;
